import React from 'react';
import { StyledDivider } from './Divider.styled';
var Divider = function () { return React.createElement(StyledDivider, null); };
export { Divider };
//# sourceMappingURL=Divider.js.map